import Storage from "web-storage-cache"

const localStorage = new Storage()

export const set = <T>(key:string, value:T, expires=7):void => {
    localStorage.set(key, value, {exp : 3600 * 24 * expires})
}

export const get = <T>(key:string):T => {
    return localStorage.get(key)
}

export const remove = (key:string):void => {
    localStorage.delete(key)
}

export const clear = ():void => {
    localStorage.clear();
    window.sessionStorage.clear();
}

export const setSession =  (key:string, value:string):void => {
    window.sessionStorage.setItem(key, value)
}
export const getSession =  (key:string):string|null => {
    return window.sessionStorage.getItem(key)
}